export const SSO_LINK_STATUSES = {
    LOADING: 'loading',
    SUCCESS: 'success',
    FAILED: 'failed',
} as const;

export type SsoLinkStatus = (typeof SSO_LINK_STATUSES)[keyof typeof SSO_LINK_STATUSES];

export const isFailed = (status?: string | null): boolean => status === SSO_LINK_STATUSES.FAILED;
